import React from "react";
import { Grid, Box, Typography, Tooltip } from "@material-ui/core";
import { useSelector } from "react-redux";
import moment from "moment";

import { ContractDetailTabText } from "./style";
import { formatCurrency } from "../../../util/formatCurrency";

const ContractDetailTab = () => {
  const {
    adminContractDetails: { contractDetails = {}, tenderDetails = {} },
  } = useSelector((state) => state.admin);

  const details = [
    { title: "Project Title", value: contractDetails.contractName || "Not available", maxLength: 120 },
    { title: "Project Description", value: tenderDetails.description || "Not available", maxLength: 120 },
    { title: "Budget Description", value: contractDetails.budgetDescription || "Not available", maxLength: 120 },
    { title: "Budget Year", value: tenderDetails.procurementYear || "Not available" },
    { title: "Budgeted Amount	", value: tenderDetails.budgetAmount ? formatCurrency(tenderDetails.budgetAmount || 0, true) : "Not available" },
    { title: "Procurement Plan	", value: !!contractDetails.budgetDescription ? "Yes" : "No" || "Not available" }, // depends on busgdget desc
    {
      title: "Tender Period	",
      value: `${moment(tenderDetails.publishedDate).format("DD-MM-yyyy")} to ${moment(tenderDetails.deadline).format(
        "DD-MM-yyyy"
      )}`,
    },
    { title: "Procuring Entity / SubSector	", value: contractDetails.ministryname || "Not available", maxLength: 120 },
    { title: "Procurement Category	", value: tenderDetails.procurementCategory || "Not available" },

    { title: "Bid Solicitation Date	", value: tenderDetails.publishedDate ? moment(tenderDetails.publishedDate).format("DD MMM, yyyy") : "Not available" },
    { title: "Bid Opening Date		", value: tenderDetails.deadline ? moment(tenderDetails.deadline).format("DD MMMM, yyyy") : "Not available" },
  ];

  return (
    <>
      <Box style={{ background: "#e4e9ec", padding: 20 }}>
        <Typography variant="h6" style={{ color: "#5F7483" }}>
          Award Details
        </Typography>
        <Typography style={{ color: "#5F7483" }}>Current Procurement Stage: {tenderDetails?.procurementStage || 'Implementation Stage'}</Typography>
      </Box>
      {details.map((detail, i) => (
        <Grid key={i} style={{ borderBottom: "1px solid #CBD4DA" }} container>
          <Grid item xs={12} sm={3}>
            <ContractDetailTabText style={{ background: "#e4e9ec", boxShadow: "0px -1px 0px #C9D4DB" }}>
              {detail.title}
            </ContractDetailTabText>
          </Grid>
          <Grid item xs={12} sm={9} style={{ borderLeft: "1px solid #CBD4DA" }}>
            {detail.maxLength && detail.length > detail.maxLength ? (
              <Tooltip title={detail.value} aria-label="add">
                <ContractDetailTabText>
                  {detail.value.length > detail.maxLength ? `${detail.value.substr(0, detail.maxLength)}...` : detail.value}
                </ContractDetailTabText>
              </Tooltip>
            ) : (
              <ContractDetailTabText>{detail.value}</ContractDetailTabText>
            )}
          </Grid>
        </Grid>
      ))}
    </>
  );
};

export default ContractDetailTab;
